import { render, staticRenderFns } from "./SGObjectStorages.vue?vue&type=template&id=0cfd5490"
import script from "./SGObjectStorages.vue?vue&type=script&lang=js"
export * from "./SGObjectStorages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports